module.exports = __webpack_public_path__ + "img/main_kfw.8c932e4f.jpg";